// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"HeaderTitle_titleWrapper___N2aF","title":"HeaderTitle_title__1c1ve","closeIcon":"HeaderTitle_closeIcon__3ryWT","titleText":"HeaderTitle_titleText__R8ECW"};